/* eslint-disable */
import React from "react";
import {
    TextField,
    SimpleFormIterator,
    FormDataConsumer,
    FormTab,
    required,
    useRecordContext,
    useResourceContext,
    useDataProvider,
    ReferenceInput,
    ReferenceArrayInput,
    maxLength,
    Button,
    useGetMany,
    useGetOne
} from "react-admin";

import LanguageSelector from '../../../lib/LanguageSelector';
import { HECOSCodesInput, PrsbAccreditations, TitleLengthCheck, validDatesValidation,validDateValidation } from "../../../lib/CommonComponents";
import { VersioningTypeInput } from "../../../lib/VersioningTypeInput";
import { Typography, Box, styled, Chip, Divider, Button as MUIButton} from '@mui/material';
import CourseVersionLinkField from "../../../lib/CourseVersionLinkField";
import {
    ArrayInput,
    AutocompleteInput,
    BooleanInput,
    DateInput,
    NumberInput,
    RichTextInput,

    SelectArrayInput,
    TextInput
} from "../../../lib/wrappers/Inputs";

var titleStyle = { color: "#AE223F" }
var labelStyle = {
    color: '#000000',
    opacity: 0.8,
    padding: 0,
    fontsize: 1,
    fontweight: 400, lineheight: 1, letterspacing: 0.00938
}
const StyledRichTextInput = styled(RichTextInput)({
    paddingTop: "10px",
});

function compareDates(setDate) {
    // Get today's date
    const today = new Date();
  
    // Parse the provided set date string into a Date object
    const parsedSetDate = new Date(setDate);
  
    // Compare the two dates
    if (isNaN(parsedSetDate.getTime())) {
      // Invalid date string
      return false;
    } 
    // Today is before the set date.
    else if (today < parsedSetDate) {
      return false;
    } 
    // Today is after the set date.
    else if (today > parsedSetDate) {
      return true;
    } 
    //Today is the same as the set date.
    else {
      return true;
    }
  }

export const CourseInformationInputs = (props) => {
    const resource = useResourceContext();
    const record = useRecordContext();
    const dataProvider = useDataProvider();
    const facFilter = (date) => {
        if(compareDates(date)){
            return {isAcademic: true, current: true, structureId: '2'};
        }
        else{
            return {isAcademic: true, current: true};
        }
    }
    const facSubFilter = (date) => {
        if(compareDates(date)){
            return {current: true, type_id: '5.0'};
        }
        else{
            return {current: true};
        }
    }

    const handlePDF = async () => {
        try {
          //build Id
          const id = record?.veroId + "-" + record?.version;
          // Use the dataProvider to make API requests
          const additionalData = await dataProvider.getOne('PDFSpec', { id: id});
          ///use data 
          console.log('Additional Data:', additionalData);
        } catch (error) {
          console.error('Error fetching additional data:', error);
        }
      };
  

    return <FormTab label="Course Information" {...props}>
        <Box display="flex" width={1} sx={{ height: '40px', borderBottom: '1px solid #AE223F', marginBottom: '15px', paddingBottom: '10px' }} >
            <Box flex={4}>
                <Typography variant="h6" style={titleStyle}>
                    Course | <small><TextField source="id" label={false} /></small> | <small><TextField source="courseCode" label={false} /></small>
                </Typography>
            </Box>
            <Box flex={1} display="flex" justifyContent="flex-end" >
                <Button variant="outlined" href={"/#/CourseModules/" + record?.id} label="Course Module Information" />
            </Box>
            <Box flex={1} display="flex" justifyContent="flex-end" >
                <MUIButton variant="outlined" onClick={handlePDF} label="Send Course Spec PDF"> Send Course PDF</MUIButton>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1} >
                {resource === 'Course' && record?.perpetuallyValidated ? (
                    <Chip label="Perpetually Validated" color="primary" variant="outlined" />

                ) : ("")}
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                {resource === 'Course' && record?.id ? (
                    <CourseVersionLinkField source="version" id={record?.id} />
                ) : (
                    record?.id && <TextField source="version" />
                )}
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '5px' }}><b style={labelStyle}><Chip sx={{fontSize: '1.2em'}} label="General"/></b></Divider>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={5}>
            {resource === 'Course' && (record?.statusId === 'STS000012' || record?.statusId === undefined || record?.id === undefined) ? (
                    <TextInput source="Title" validate={[required(), TitleLengthCheck]}  fullWidth />
                ) : (
                    <TextInput source="Title" validate={[required(), TitleLengthCheck]} disabled fullWidth />
                )}

            </Box>
            <Box flex={2} ml="0.5em">
                <DateInput source="validationFrom" fullWidth validate={required()} />
            </Box>
            <Box flex={2} ml="0.5em">
                <DateInput source="validationTo" fullWidth validate={[required(), validDatesValidation]} />
            </Box>
            <Box flex={2} ml="0.5em">
                <ReferenceInput reference="Status" source="statusId" fullWidth>
                    <AutocompleteInput optionText="Title" disabled={props.create} />
                </ReferenceInput>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={2}>
                <DateInput source="approvedDate" fullWidth validate={[required(),validDateValidation]} />
            </Box>
            <Box flex={2} ml="0.5em">
                <DateInput source="dateClosed" validate={validDateValidation} fullWidth />
            </Box>
            <Box flex={2} ml="0.5em">
                <DateInput source="finalEnrolment" validate={validDateValidation} fullWidth />
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={2}>
                <ReferenceInput reference="Faculty" source="facultyId" linkType="edit" fullWidth filter={facFilter()}>
                    <AutocompleteInput optionText={optionTextFaculty} />
                </ReferenceInput>
            </Box>
            <Box flex={2} ml="0.5em">
                <ReferenceInput reference="FacultySubGroup" source="subjectId" fullWidth filter={facSubFilter()}>
                    <AutocompleteInput optionText={optionTextFacultyGroup} />
                </ReferenceInput>
            </Box>
            <Box flex={2} ml="0.5em">
                <ReferenceInput reference="AwardingBody" source="awardingBodyId" label="myroot.AwardingBody" fullWidth>
                    <AutocompleteInput optionText="name" />
                </ReferenceInput>
            </Box>
        </Box>
        {/* <Typography variant="h6" style={titleStyle} gutterBottom fullWidth>
            Codes and Supporting Items
        </Typography> */}
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '5px', marginTop: '30px' }}><b style={labelStyle}><Chip sx={{fontSize: '1.2em'}} label="Exit Points"/></b></Divider>
            
            <ArrayInput source="exitPoints" label={false}>
                <SimpleFormIterator disableReordering fullWidth>
                    <FormDataConsumer>
                        {({ getSource, scopedFormData, formData }) => {
                            return <Box width={1}>

                                <Box display="flex">
                                    <Box flex={2}>
                                        <TextInput source={getSource("certificateTitle")} label="myroot.CertificateTitle" fullWidth />
                                    </Box>
                                    <Box flex={2} ml="0.5em">
                                        <TextInput source={getSource("certificateTitleWelsh")} label="myroot.CertificateTitleWelsh" fullWidth />
                                    </Box>
                                </Box>

                                <Box display="flex">
                                    <Box flex={1}>
                                        <ReferenceInput reference="QualificationType" source={getSource("qualificationId")} label="myroot.qualificationAims">
                                            <AutocompleteInput optionText="Title" fullWidth />
                                        </ReferenceInput>
                                    </Box>
                                    <Box flex={1} ml="0.5em">
                                        <AutocompleteInput source={getSource("intermediateOrFinal")} label='Final / Intermediate / Exit'
                                            choices={[
                                                { id: 'Exit', name: 'Exit' },
                                                { id: 'Intermediate', name: 'Intermediate' },
                                                { id: 'Final', name: 'Final' },
                                            ]} fullWidth>
                                        </AutocompleteInput>
                                    </Box>
                                    <Box flex={4} ml="0.5em">
                                        <TextInput source={getSource("criteria")} label="Criteria" fullWidth multiline />
                                    </Box>
                                </Box>

                            </Box>;

                        }}
                    </FormDataConsumer>
                </SimpleFormIterator>
            </ArrayInput>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '5px', marginTop: '30px' }}><b style={labelStyle}><Chip sx={{fontSize: '1.2em'}} label="Modes of study / HECoS Codes"/> </b></Divider>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={3} width={1}>
                <ReferenceArrayInput reference="ModeOfStudy" source="modesOfStudy">
                    <SelectArrayInput optionText="Title" optionValue="id" label="myroot.ModesOfStudy" fullWidth />
                </ReferenceArrayInput>
            </Box>
            <Box flex={3} ml="1.5em">
                <HECOSCodesInput {...props} />
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '5px', marginTop: '30px'  }}><b style={labelStyle}> <Chip sx={{fontSize: '1.2em'}} label="QAA Benchmarks"/></b></Divider>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <RichTextInput source="qaaBenchmarks" fullWidth label={false}/>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '5px', marginTop: '30px'  }}><b style={labelStyle}><Chip sx={{fontSize: '1.2em'}} label="UCAS Code / Intakes / Course Level"/></b></Divider>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={2}>
                <TextInput source="ucasCode" fullWidth />
            </Box>
            <Box flex={2} ml="0.5em">
                <NumberInput source="numberOfIntakes" fullWidth />
            </Box>
            <Box flex={2} ml="0.5em">
                <ReferenceInput reference="CourseLevel" source="courseLevelId" fullWidth>
                    <AutocompleteInput optionText="description" />
                </ReferenceInput>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '5px', marginTop: '30px'  }}><b style={labelStyle}> <Chip sx={{fontSize: '1.2em'}} label="PSRB Accreditations"/></b></Divider>
            </Box>
        </Box>
        <PrsbAccreditations />
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '5px', marginTop: '30px'  }}><b style={labelStyle}><Chip sx={{fontSize: '1.2em'}} label="Course Specific Regs / Language / Additional Study"/></b></Divider>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={2} ml="0.5em">
                <BooleanInput source="courseSpecificRegs" fullWidth />
            </Box>
            <Box flex={2} ml="0.5em">
                <FormDataConsumer>
                    {({ formData, getSource, ...rest }) => <LanguageSelector {...props} formData={formData} />}
                </FormDataConsumer>
            </Box>
            <Box flex={2} ml="0.5em">
                <AutocompleteInput source="additionalStudy" choices={[
                    { id: 'NoFoundationYear', name: 'No foundation year' },
                    { id: 'Integrated', name: 'Integrated' },
                    { id: 'Standalone', name: 'Standalone' }
                ]} fullWidth />

            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '5px', marginTop: '30px'  }}><b style={labelStyle}><Chip sx={{fontSize: '1.2em'}} label="Progression Routes" /></b></Divider>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={2}>
                <ArrayInput source="progressionForOtherCourses" fullWidth>
                    <SimpleFormIterator disableReordering fullWidth>
                        <ReferenceInput reference="Course" source="courseId">
                            <AutocompleteInput optionText={CourseTitleRenderer} label="myroot.course" fullWidth />
                        </ReferenceInput>
                        <ReferenceArrayInput reference="CampusLocation" source="campusLocationIds" fullWidth>
                            <SelectArrayInput optionText="Title" label="myroot.campusLocation" fullWidth />
                        </ReferenceArrayInput>
                    </SimpleFormIterator>
                </ArrayInput>
            </Box>
            <Box flex={2} ml="0.5em">
                <ArrayInput source="progressionRoutes" label={false}>
                    <SimpleFormIterator disableReordering fullWidth>
                        <StyledRichTextInput source="progressionInfo" label={false} fullWidth />
                    </SimpleFormIterator>
                </ArrayInput>
            </Box>
        </Box>

        <Box display="flex" width={1}>
            <Box flex={2}>
                <ReferenceArrayInput reference="Tier4Arrangement" source="tier4ArrangementIds" fullWidth>
                    <SelectArrayInput optionText="Title" fullWidth />
                </ReferenceArrayInput>
            </Box>
        </Box>
        {resource === "Course" &&
            <VersioningTypeInput source="versioningType" resource={resource} />
        }
    </FormTab>
}
export const CourseTitleRenderer = choice => `${choice.id} - ${choice.Title}`;
export const ModuleTitleRenderer = choice => `${choice.moduleCode} - ${choice.shortTitle}`;
export const optionTextFaculty = choice => `${choice.description}${choice.structureId != '2' ? ' - (Old)' : ''}`;
export const optionTextFacultyGroup = choice => `${choice.description}${choice.type_id != '5.0' ? ' - (Old)' : ''}`;
